const routes = [
    {
        path: "/online/registration/login",
        component: () => import("../pages/Login"),
    },
    {
        path: "/online/registration",
        component: () => import("../pages/Index"),
        meta: {
            isOnlineRegistration: true
        },
        component_full_path: 'onlineRegistration/pages/Index.vue'
    },
    {
        path: "/online/registration/success",
        component: () => import("../pages/Success"),
    }
];

export default routes;
